// Vue
import { Component, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { EventBus } from "@mgs/ci2019-common/src/mixins/event_bus/EventBus";
import { ModuleHelperMixin } from "#/common/ModuleHelperMixin";
import { Counter } from "#/components/counter/Counter";
import { Api } from "#/api";
import { FastSearchResultEntry } from "#/common/interfaces/FastSearchResult";
// Template
import template from "./template.vue";
import { getTranslatedImage } from "#/common/ModuleHelpers";
import { ImageFader } from "#/components/image_fader/ImageFader";
import { AufbauplusHeadline } from "#/components/aufbauplus_headline/AufbauplusHeadline";
import moment from "moment";

@Component({
  mixins: [template],
  components: {
    Counter,
    ImageFader,
    AufbauplusHeadline,
  },
})
export class SliderItemImage extends mixins(EventBus, ModuleHelperMixin) {
  @Prop({ default: true })
  public shouldNotify!: boolean;

  @Prop({ default: false })
  public active!: boolean;

  @Prop()
  public slide!: object;

  @Prop()
  public totalSlides!: number;

  @Prop()
  public instance!: object;

  @Prop()
  public lang!: string;

  @Prop()
  public country!: string;

  @Prop({ default: null })
  public height!: number | null;

  private searchResult: FastSearchResultEntry[] = [];

  private videoStarted = false;

  public created() {
    if (this.shouldNotify) {
      let duration = this.slide["duration"] * 1000;
      if (this.slide["images"] && this.slide["images"].length > 1) {
        duration = 0;
        this.slide["images"].forEach((image) => {
          duration += image.duration * 1000;
        });
      }
      this.dispatch("Slider", "registerSlide", [
        {
          active: this.active,
          duration: duration,
          text: "",
          component: "SliderItemImage",
          props: {
            slide: this.slide,
            lang: this.lang,
            instance: this.instance,
            height: this.height,
            totalSlides: this.totalSlides,
          },
        },
      ]);
    }
  }

  get imageFaderData() {
    let result: any = [];

    this.slide["images"].forEach((image) => {
      result.push({
        src: getTranslatedImage(image["image"], this.lang, "xlarge"),
        duration: image["duration"],
      });
    });
    return result;
  }

  private heightStyle(slide) {
    let styles = {};

    if (this.height && this.height > 0) {
      styles["height"] = this.height + "px";
    }

    if (slide.image && slide.image != "") {
      styles["background-image"] =
        "url(" +
        this.getTranslatedImage(slide.image, this.lang, "xlarge") +
        ")";
    }

    return styles;
  }

  get headlineTheme() {
    return this.slide["font-color"] == "white" ? "secondary" : "primary";
  }

  get richTextTheme() {
    return this.slide["font-color"] == "white" ? "primary" : "secondary";
  }

  get counterFontColor() {
    if (this.slide["counter_color"] == "inherit") {
      return this.slide["font-color"];
    } else {
      return this.slide["counter_color"];
    }
  }

  public buttonTheme(type) {
    switch (type) {
      case "wb-e-btn-1":
        return "primary";
      case "wb-e-btn-2":
        return "default";
      case "wb-e-btn-3":
        return "inverted";
      case "button_outline":
        return "outline-secondary";
      default:
        return "default";
    }
  }

  public handleSearch(query: string) {
    this.dispatch("Slider", "animatedState", false);
    this.updateResultList(query);
  }

  public onSearchOpen() {
    this.dispatch("Slider", "animatedState", false);
  }

  public async updateResultList(query: string) {
    if (query.length > 0) {
      let result = await Api.pageService.fastSerach(
        query,
        this.$store.page!.page!.id,
        this.lang
      );
      this.searchResult = result.result;
    } else {
      this.searchResult = [];
    }
  }

  public onVideoPlay() {
    this.videoStarted = true;
  }

  get videoStartedClass() {
    return this.videoStarted && !this.slide["video_autoplay"]
      ? `${this.$appPrefix}-cms-slider-item-image__content--video-started`
      : "";
  }

  public handleFastSearchChange(value) {
    window.location.href = value;
  }

  public getTargetDate(instance) {
    return moment(
      instance.counter.date + " " + instance.counter.time,
      "DD-MM-YYYY hh:mm:ss"
    ).toDate();
  }
}
